import {
  ADD_CUSTOM_VARIABLE_VALUE_FAIL,
  ADD_CUSTOM_VARIABLE_VALUE_REQUEST,
  ADD_CUSTOM_VARIABLE_VALUE_SUCCESS,
  DELETE_CUSTOM_VARIABLE_VALUE_FAIL,
  DELETE_CUSTOM_VARIABLE_VALUE_REQUEST,
  DELETE_CUSTOM_VARIABLE_VALUE_SUCCESS,
  GET_CUSTOM_VARIABLE_VALUE_LIST_FAIL,
  GET_CUSTOM_VARIABLE_VALUE_LIST_REQUEST,
  GET_CUSTOM_VARIABLE_VALUE_LIST_SUCCESS,
  UPDATE_CUSTOM_VARIABLE_VALUE_FAIL,
  UPDATE_CUSTOM_VARIABLE_VALUE_REQUEST,
  UPDATE_CUSTOM_VARIABLE_VALUE_SUCCESS,
} from "../constant";

const initialState = {
  customVariableValueList: [],

  fetchigValueList: false,
  changingVaribleValue: false,
  deletingVaribleValue: false,
};

const variableValueReducer = (state = initialState, action) => {
  switch (action.type) {
    //Get Custom Variable
    case GET_CUSTOM_VARIABLE_VALUE_LIST_REQUEST:
      return {
        ...state,
        customVariableValueList: [],
        fetchigValueList: true,
      };
    case GET_CUSTOM_VARIABLE_VALUE_LIST_SUCCESS:
      return {
        ...state,
        customVariableValueList: action.payload,
        fetchigValueList: false,
      };
    case GET_CUSTOM_VARIABLE_VALUE_LIST_FAIL:
      return {
        ...state,
        customVariableValueList: [],
        fetchigValueList: false,
      };

    case ADD_CUSTOM_VARIABLE_VALUE_REQUEST:
      return {
        ...state,
        changingVaribleValue: true,
      };
    case ADD_CUSTOM_VARIABLE_VALUE_SUCCESS:
      return {
        ...state,
        changingVaribleValue: false,
      };
    case ADD_CUSTOM_VARIABLE_VALUE_FAIL:
      return {
        ...state,
        changingVaribleValue: false,
      };

    case UPDATE_CUSTOM_VARIABLE_VALUE_REQUEST:
      return {
        ...state,
        changingVaribleValue: true,
      };
    case UPDATE_CUSTOM_VARIABLE_VALUE_SUCCESS:
      return {
        ...state,
        changingVaribleValue: false,
      };
    case UPDATE_CUSTOM_VARIABLE_VALUE_FAIL:
      return {
        ...state,
        changingVaribleValue: false,
      };

    case DELETE_CUSTOM_VARIABLE_VALUE_REQUEST:
      return {
        ...state,
        deletingVaribleValue: true,
      };
    case DELETE_CUSTOM_VARIABLE_VALUE_SUCCESS:
      return {
        ...state,
        deletingVaribleValue: false,
      };
    case DELETE_CUSTOM_VARIABLE_VALUE_FAIL:
      return {
        ...state,
        deletingVaribleValue: false,
      };
    //Default
    default:
      return state;
  }
};

export { variableValueReducer };
